/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_PORTFOLIO_CREDENTIAL_SCHEMA = gql`
query GetStudenPortfolioPerCredSchema($filter: UniqStudPortfolioFilterInput!, $getStudenPortfolioShareableLinkFilter2: UniqStudPortfolioFilterInput!, $getStudenPortfolioPdfFilter2: UniqStudPortfolioFilterInput!) {
  getStudenPortfolioPerCredSchema(filter: $filter) {
    data {
      id
      _id
      name
      logo
      description
      jsonFormat
      jsonldFormat
      selfAttested
      credentials
    }
    portfolio
    currentPage
    pageSize
    totalCount
    totalPages
  }
  getStudenPortfolioShareableLink(filter: $getStudenPortfolioShareableLinkFilter2)
  getStudenPortfolioPdf(filter: $getStudenPortfolioPdfFilter2)
}
`;
